import React, { createContext, useContext, useState } from "react";
import Toast from "./Toast";
import "./toast.css";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

export default function ToastContainer({ children }) {
    const [toasts, setToasts] = useState([]);

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    const addToast = (type, message, duration = 5000) => {
        const id = Date.now();
        setToasts((prev) => [...prev, { id, type, message }]);

        setTimeout(() => removeToast(id), duration);
    };

    return (
        <ToastContext.Provider
            value={{
                success: (msg, d) => addToast("success", msg, d),
                error: (msg, d) => addToast("error", msg, d),
                warning: (msg, d) => addToast("warning", msg, d), // ✅ THÊM DÒNG NÀY
            }}
        >

            {children}

            <div className="toast-container">
                {toasts.map((t) => (
                    <Toast
                        key={t.id}
                        id={t.id}
                        type={t.type}
                        message={t.message}
                        onClose={removeToast}
                    />
                ))}
            </div>
        </ToastContext.Provider>
    );
}
